import axios from "axios";

const B_URL = process.env.REACT_APP_LOGINURL

const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
};

const getAddresses = () => {
    var payload = {
        functionName: "GetAddresses",
        postData: {},
    };
    return axios.post(B_URL + 'AddressModule/GetAddresses', payload, { headers });
};

const addAddress = (addressData) => {
    var payload = {
        functionName: "AddAddress",
        postData: addressData,
    };
    return axios.post(B_URL + 'AddressModule/AddAddress', payload, { headers });
};

const updateAddress = (addressData) => {
    var payload = {
        functionName: "UpdateAddress",
        postData: addressData,
    };
    return axios.post(B_URL + 'AddressModule/UpdateAddress', payload, { headers });
};

const deleteAddress = (addressId) => {
    console.log("DeleteAddress" , addressId);
    var payload = {
        functionName: "DeleteAddress",
        postData: {
            "address_id": addressId
        },
    };
    return axios.post(B_URL + 'AddressModule/DeleteAddress', payload, { headers });
};

const AddressService = {
    getAddresses,
    addAddress,
    updateAddress,
    deleteAddress
};

export default AddressService;